module.exports = __webpack_public_path__ + "img/2.45935740.jpg";